import type { StreamingChatId } from "@storytell/streaming";

// Long enough that sweeping the pointer across a list warms nothing, short
// enough to land well before a deliberate click.
const INTENT_DELAY_MS = 100;

/**
 * Handlers for a chat link that warm the chat once the pointer rests on it or
 * focus lands on it, and cancel if it leaves first. Touch pointers are skipped:
 * a tap's hover arrives with its click, which loads the chat anyway.
 */
export const prefetchChatOnIntent = (chatId: string, prefetch: (chatIds: StreamingChatId[]) => void) => {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const arm = () => {
    clearTimeout(timer);
    timer = setTimeout(() => prefetch([chatId as StreamingChatId]), INTENT_DELAY_MS);
  };
  const cancel = () => clearTimeout(timer);
  return {
    onPointerEnter: (e: PointerEvent) => {
      if (e.pointerType !== "touch") arm();
    },
    onPointerLeave: cancel,
    onFocus: arm,
    onBlur: cancel,
  };
};
